const getDealDetails = ({
  price,
  reducedPrice,
  formatCurrency,
  discounted,
}) => {
  let formattedReducedPrice = null;
  const deal = null;
  const dealAria = null;
  let formattedBenefitValue = null;
  let formattedDiscountedPrice = null;

  const hasPromotionalDiscount =
    discounted && discounted.discountBenefitValue !== undefined;

  if (hasPromotionalDiscount) {
    formattedBenefitValue = `-${discounted.discountBenefitValue}%`;
    formattedDiscountedPrice =
      discounted.text || formatCurrency(discounted.value);
  }

  if (reducedPrice) {
    formattedReducedPrice = formatCurrency(reducedPrice);
  }

  return {
    formattedPrice: formatCurrency(price),
    formattedReducedPrice,
    deal,
    dealAria,
    formattedBenefitValue,
    discountCode: discounted?.discountCode || null,
    formattedDiscountedPrice,
  };
};

export default getDealDetails;
